import { OnSchedResponse } from '../../OnSchedResponse'
import { OnSchedRest }     from '../../OnSchedRest'


export const AvailableTime = (event, element) => {
    var timeClicked = event.target;
    var el = document.getElementById(element.id);
    el.scrollIntoView();

    var detail = Object.assign({}, timeClicked.dataset)
    detail.serviceId = element.params.serviceId;

    var timeClickedEvt = new CustomEvent("clickTime", { detail });
    el.dispatchEvent(timeClickedEvt);

  element.timerId = null;
  var postData = Object.assign({}, element.params);

  const addResourceConferenceUrl = () => new Promise(resolve => {
    // Resource Conference Url
    if (element.options.resourceConferenceUrl && detail.resourceId) {
      // GET Resource before the POST
      const resourceUrl = element.onsched.apiBaseUrl + '/resources/' + detail.resourceId;
      OnSchedRest.Get(resourceUrl, resolve);
    }
    else {
      console.log('resourceConferenceUrl, detail', element.options.resourceConferenceUrl, detail)
      resolve();
    }
  })

  // Check for timezone name
  const timezoneSelected = document.getElementById('onsched-timezone-hidden-input');
  if (timezoneSelected?.value) {
    postData.timezoneName = timezoneSelected.value;
  }

  // check if resourceIds is used
  if (timeClicked.dataset.resourceIds) {
    postData.resourceIds = "" + timeClicked.dataset.resourceIds;
  }
  else {
    postData.resourceId = "" + timeClicked.dataset.resourceId;
  }
  postData.startDateTime = timeClicked.dataset.startDateTime;
  postData.endDateTime = timeClicked.dataset.endDateTime;
  if (OnSchedHelpers.IsEmpty(element.params.customerId) === false)
      postData.customerId = element.params.customerId;

  OnSchedHelpers.ShowProgress();
  
  var appointmentsUrl = element.onsched.apiBaseUrl + "/appointments";

  // Remove ambiguous resource to hand BOOKING-107 validation
  if (postData.resourceIds && postData.resourceId) {
    delete postData.resourceId;
  }

  // Check for reschedule
  if (element.options.reschedule && element.params.appointmentId) {
    appointmentsUrl += '/' + element.params.appointmentId + '/reschedule';

    // Reschedule existing appointment
    postData = {
      serviceId: element.params.serviceId,
      startDateTime: timeClicked.dataset.startDateTime,
      endDateTime: timeClicked.dataset.endDateTime,
    }

    addResourceConferenceUrl().then(resourceResponse => {
      if (element.options.resourceConferenceUrl) {
        postData.location = resourceResponse?.contact?.conferenceInfo;
      }
      
      OnSchedRest.Put(appointmentsUrl, postData, function (response) {
        // Reschedule response
        OnSchedResponse.RescheduleAppointment(element, response)
      })
    })
  }
  else {
    // New appointment book
    
    // Invoke POST /appointments endpoint
    if (OnSchedHelpers.IsNotEmpty(element.params.completeBooking) &&
        OnSchedHelpers.IsNotEmpty(element.params.customerId) &&
        element.params.completeBooking !== "IN") {
        appointmentsUrl = OnSchedHelpers.AddUrlParam(appointmentsUrl, "completeBooking", element.params.completeBooking);
    }
  
    // TWO DIFFERENT FLOWS ARE POSSIBLE
    // 1. Render the booking form
    // 2. Complete the booking, with supplied information
  

      addResourceConferenceUrl().then(resourceResponse => {
        if (element.options.resourceConferenceUrl) {
          postData.location = resourceResponse?.contact?.conferenceInfo;
          delete postData.timezoneName;
          delete postData.tzOffset;
        }
        OnSchedRest.Post(appointmentsUrl, postData, function (response) {
            OnSchedResponse.PostAppointment(element, response);
        })
      })
  }
}
